class UserService {
  static customerId = -1

  static setCustomerId = (customerId = -1) => {
    UserService.customerId = customerId
  }
}

export default UserService
